module.exports = __webpack_public_path__ + "static/media/homepage-header.0f21e261.png";